<template>
  <div class="print-tag">
    <transition
      :name="effect"
      mode="out-in"
    >
      <print-labels v-if="$toggle.feature.nonSegregatedBatchList" />

      <print-tag-main-view v-else />
    </transition>
  </div>
</template>

<script>
import printTagMainView from './PrintTagMainView'
import PrintLabels from '../PrintLabels/PrintLabels'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'PrintTag',
  components: {
    'print-tag-main-view': printTagMainView,
    PrintLabels
  },
  data: () => ({
    effect: 'slide-fade'
  }),
  computed: {
    ...mapGetters(['isBatchFilterShowing', 'preference'])
  },
  watch: {
    isBatchFilterShowing: function (newVal) {
      if (newVal) {
        this.effect = 'leave-fade'
      } else {
        this.effect = 'slide-fade'
      }
    },
    $route (to, from) {
      this.setListTypeByPath()
    }
  },
  mounted () {
    this.setListTypeByPath()
  },
  methods: {
    ...mapActions(['setFilterShowOff', 'setPrintTagListType', 'setFilterShowOff']),
    setListTypeByPath () {
      if (this.$route.path === '/print-tag/filter') {
        this.setFilterShowOff(true)
      } else {
        this.setFilterShowOff(false)
        if (this.$route.path === '/print-tag/batches') {
          this.setPrintTagListType('batches')
        } else if (this.$route.path === '/print-tag/samples') {
          this.setPrintTagListType('samples')
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../static/stylesheets/variables";
@import "../../../static/stylesheets/components/orders/empty-cart";

.print-tag {
  height: 100%;

  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter {
    transform: translateY(300px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateY(-400px);
    opacity: 0;
  }
  .leave-fade-enter-active {
    transition: all 0.3s ease;
  }
  .leave-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .leave-fade-enter {
    transform: translateY(-450px);
    opacity: 0;
  }
  .leave-fade-leave-to {
    transform: translateY(450px);
    opacity: 0;
  }
  .alternative-subheader {
    position: initial;
  }
}

.export-print-tag.modals .md-dialog {
  min-width: 660px;
  min-height: 230px;
  border-radius: 7px;

  &-title {
    padding: 32px 34px 13px;
    font-size: 24px;
    font-weight: 300;
    letter-spacing: -0.3px;
    color: rgba(96, 96, 96, 0.87);
  }

  .close-button {
    position: absolute;
    top: 23px;
    right: 38px;
  }

  p {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    letter-spacing: -0.2px;
    text-align: center;
    color: #303030;
    margin-bottom: 10px;
  }
}

.print-tag-modal-details {
  &__title {
    font-weight: 500;
    color: #4a4a4a;
    font-family: Roboto, sans-serif;
    font-size: 18px;

    .md-icon {
      margin-right: 0.5em;
    }
  }

  .md-dialog-content {
    padding-top: 0px;
  }

  &__description {
    font-family: Roboto, sans-serif;
    color: #617173;
    font-weight: normal;

    p {
      font-size: 15px !important;
      text-align: left !important;
    }
    span {
      font-weight: 500;
    }
  }

  &__button {
    width: 40%;
    margin: 3% 3% 0 3%;
  }

  .button-single {
    float: left;
    width: 60%;
    margin-left: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}
</style>
